export default [
  {
    path: 'nps/index',
    name: 'npsIndex',
    meta: {
      title: 'NPS调研',
    },
    component: () => import('@/views/nps/index.vue')
  },
]